// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Vessel\ApiVessel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BowThruster, BowThrusterData, BowThrusterOptions } from 'data/models/BowThruster';
import { Country, CountryData, CountryOptions } from 'data/models/Country';
import { DeclarationOfSecurity, DeclarationOfSecurityData, DeclarationOfSecurityOptions } from 'data/models/DeclarationOfSecurity';
import { LloydServiceVessel, LloydServiceVesselData, LloydServiceVesselOptions } from 'data/models/LloydServiceVessel';
import { MarineTrafficServiceVessel, MarineTrafficServiceVesselData, MarineTrafficServiceVesselOptions } from 'data/models/MarineTrafficServiceVessel';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { OverrideServiceVessel, OverrideServiceVesselData, OverrideServiceVesselOptions } from 'data/models/OverrideServiceVessel';
import { PilotShiphandlingNote, PilotShiphandlingNoteData, PilotShiphandlingNoteOptions } from 'data/models/PilotShiphandlingNote';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { PSixServiceVessel, PSixServiceVesselData, PSixServiceVesselOptions } from 'data/models/PSixServiceVessel';
import { VesselChange, VesselChangeData, VesselChangeOptions } from 'data/models/VesselChange';
import { VesselStatus } from 'server/enums/VesselStatus';

// VesselData is the class that Vessel serializes to/from
export interface VesselData {
    Id : number;
    Url : string | null;
	
    Changes : VesselChangeData[] | null;
    Flag : CountryData | null;
    FlagId : number | null;
    LloydServiceVessel : LloydServiceVesselData | null;
    LloydServiceVesselId : number | null;
    MarineTrafficServiceVessel : MarineTrafficServiceVesselData | null;
    MarineTrafficServiceVesselId : number | null;
    OverrideServiceVessel : OverrideServiceVesselData | null;
    PilotShiphandlingNotes : PilotShiphandlingNoteData[] | null;
    PilotShiphandlingNotesUrl : string | null;
    PortCalls : PortCallData[] | null;
    PSixServiceVessel : PSixServiceVesselData | null;
    PSixServiceVesselId : number | null;
	
    Alias : string | null;
    AuditKey : /* GUID */ string | null;
    Beam : NullableMeasurementData;
    BowThruster : BowThrusterData;
    CallSign : string | null;
    DOS : DeclarationOfSecurityData;
    ExpectedPassengerCount : number | null;
    GrossTonnage : NullableMeasurementData;
    Guid : /* GUID */ string;
    IMO : string | null;
    IsCruiseVessel : boolean | null;
    IsGovernmentVessel : boolean;
    Length : NullableMeasurementData;
    MaxDraft : NullableMeasurementData;
    MMSID : string | null;
    Name : string | null;
    PortOfRegistry : string | null;
    Status : VesselStatus;
    VesselType : string | null;
    VIN : string | null;
}

// VesselOptions is the class which may be passed to the Vessel constructor to define optional initial data values
export interface VesselOptions {
    Id : number;
    Url? : string | null;
	
    Changes? : VesselChangeOptions[] | null;
    Flag? : CountryOptions | null;
    FlagId? : number | null;
    LloydServiceVessel? : LloydServiceVesselOptions | null;
    LloydServiceVesselId? : number | null;
    MarineTrafficServiceVessel? : MarineTrafficServiceVesselOptions | null;
    MarineTrafficServiceVesselId? : number | null;
    OverrideServiceVessel? : OverrideServiceVesselOptions | null;
    PilotShiphandlingNotes? : PilotShiphandlingNoteOptions[] | null;
    PilotShiphandlingNotesUrl? : string | null;
    PortCalls? : PortCallOptions[] | null;
    PSixServiceVessel? : PSixServiceVesselOptions | null;
    PSixServiceVesselId? : number | null;
	
    Alias? : string | null;
    AuditKey? : /* GUID */ string | null;
    Beam? : NullableMeasurementOptions;
    BowThruster? : BowThrusterOptions;
    CallSign? : string | null;
    DOS? : DeclarationOfSecurityOptions;
    ExpectedPassengerCount? : number | null;
    GrossTonnage? : NullableMeasurementOptions;
    Guid? : /* GUID */ string;
    IMO? : string | null;
    IsCruiseVessel? : boolean | null;
    IsGovernmentVessel? : boolean;
    Length? : NullableMeasurementOptions;
    MaxDraft? : NullableMeasurementOptions;
    MMSID? : string | null;
    Name? : string | null;
    PortOfRegistry? : string | null;
    Status? : VesselStatus;
    VesselType? : string | null;
    VIN? : string | null;
}

export class Vessel {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public Changes : SDataArray<VesselChange>;
    public Flag : DataSignal<Country | null>;
    public FlagId : DataSignal<number | null>;
    public LloydServiceVessel : DataSignal<LloydServiceVessel | null>;
    public LloydServiceVesselId : DataSignal<number | null>;
    public MarineTrafficServiceVessel : DataSignal<MarineTrafficServiceVessel | null>;
    public MarineTrafficServiceVesselId : DataSignal<number | null>;
    public OverrideServiceVessel : DataSignal<OverrideServiceVessel | null>;
    public PilotShiphandlingNotes : SDataArray<PilotShiphandlingNote>;
    public PilotShiphandlingNotesUrl : DataSignal<string | null>;
    public PortCalls : SDataArray<PortCall>;
    public PSixServiceVessel : DataSignal<PSixServiceVessel | null>;
    public PSixServiceVesselId : DataSignal<number | null>;
	
    public Alias : DataSignal<string | null>;
    public AuditKey : DataSignal<string | null>;
    public Beam : NullableMeasurement;
    public BowThruster : BowThruster;
    public CallSign : DataSignal<string | null>;
    public DOS : DeclarationOfSecurity;
    public ExpectedPassengerCount : DataSignal<number | null>;
    public GrossTonnage : NullableMeasurement;
    public Guid : DataSignal<string>;
    public IMO : DataSignal<string | null>;
    public IsCruiseVessel : DataSignal<boolean | null>;
    public IsGovernmentVessel : DataSignal<boolean>;
    public Length : NullableMeasurement;
    public MaxDraft : NullableMeasurement;
    public MMSID : DataSignal<string | null>;
    public Name : DataSignal<string | null>;
    public PortOfRegistry : DataSignal<string | null>;
    public Status : DataSignal<VesselStatus>;
    public VesselType : DataSignal<string | null>;
    public VIN : DataSignal<string | null>;

    constructor();
    constructor(data : VesselOptions);
    constructor(data: VesselOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.Changes = SArray<VesselChange>([]);
        this.Flag = S.value<Country | null>(null);
        this.FlagId = jsonableObservable(S.value<number | null>(data && data.FlagId !== undefined ? data.FlagId : null));
        this.LloydServiceVessel = S.value<LloydServiceVessel | null>(null);
        this.LloydServiceVesselId = jsonableObservable(S.value<number | null>(data && data.LloydServiceVesselId !== undefined ? data.LloydServiceVesselId : null));
        this.MarineTrafficServiceVessel = S.value<MarineTrafficServiceVessel | null>(null);
        this.MarineTrafficServiceVesselId = jsonableObservable(S.value<number | null>(data && data.MarineTrafficServiceVesselId !== undefined ? data.MarineTrafficServiceVesselId : null));
        this.OverrideServiceVessel = S.value<OverrideServiceVessel | null>(null);
        this.PilotShiphandlingNotes = SArray<PilotShiphandlingNote>([]);
        this.PilotShiphandlingNotesUrl = jsonableObservable(S.value<string | null>(data && data.PilotShiphandlingNotesUrl !== undefined ? data.PilotShiphandlingNotesUrl : null));
        this.PortCalls = SArray<PortCall>([]);
        this.PSixServiceVessel = S.value<PSixServiceVessel | null>(null);
        this.PSixServiceVesselId = jsonableObservable(S.value<number | null>(data && data.PSixServiceVesselId !== undefined ? data.PSixServiceVesselId : null));
	    
        this.Alias = jsonableObservable(S.value<string | null>(data && data.Alias !== undefined ? data.Alias : null));
        this.AuditKey = jsonableObservable(S.value<string | null>(data && data.AuditKey !== undefined ? data.AuditKey : null));
        this.Beam = data && data.Beam !== undefined ? new NullableMeasurement(data.Beam) : new NullableMeasurement();
        this.BowThruster = data && data.BowThruster !== undefined ? new BowThruster(data.BowThruster) : new BowThruster();
        this.CallSign = jsonableObservable(S.value<string | null>(data && data.CallSign !== undefined ? data.CallSign : null));
        this.DOS = data && data.DOS !== undefined ? new DeclarationOfSecurity(data.DOS) : new DeclarationOfSecurity();
        this.ExpectedPassengerCount = jsonableObservable(S.value<number | null>(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.GrossTonnage = data && data.GrossTonnage !== undefined ? new NullableMeasurement(data.GrossTonnage) : new NullableMeasurement();
        this.Guid = jsonableObservable(S.value<string>(data && data.Guid !== undefined ? data.Guid : '00000000-0000-0000-0000-000000000000'));
        this.IMO = jsonableObservable(S.value<string | null>(data && data.IMO !== undefined ? data.IMO : null));
        this.IsCruiseVessel = jsonableObservable(S.value<boolean | null>(data && data.IsCruiseVessel !== undefined ? data.IsCruiseVessel : null));
        this.IsGovernmentVessel = jsonableObservable(S.value<boolean>(data && data.IsGovernmentVessel !== undefined ? data.IsGovernmentVessel : false));
        this.Length = data && data.Length !== undefined ? new NullableMeasurement(data.Length) : new NullableMeasurement();
        this.MaxDraft = data && data.MaxDraft !== undefined ? new NullableMeasurement(data.MaxDraft) : new NullableMeasurement();
        this.MMSID = jsonableObservable(S.value<string | null>(data && data.MMSID !== undefined ? data.MMSID : null));
        this.Name = jsonableObservable(S.value<string | null>(data && data.Name !== undefined ? data.Name : null));
        this.PortOfRegistry = jsonableObservable(S.value<string | null>(data && data.PortOfRegistry !== undefined ? data.PortOfRegistry : null));
        this.Status = jsonableObservable(S.value<VesselStatus>(data && data.Status !== undefined ? data.Status : 0));
        this.VesselType = jsonableObservable(S.value<string | null>(data && data.VesselType !== undefined ? data.VesselType : null));
        this.VIN = jsonableObservable(S.value<string | null>(data && data.VIN !== undefined ? data.VIN : null));
    }

    static key(obj : Vessel) {
        return obj.Id();
    }
    
    static dataKey(obj : VesselOptions) {
        return obj.Id;
    }

    static update(obj : Vessel, data : VesselOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.FlagId !== undefined) obj.FlagId(data.FlagId);
            if (data.LloydServiceVesselId !== undefined) obj.LloydServiceVesselId(data.LloydServiceVesselId);
            if (data.MarineTrafficServiceVesselId !== undefined) obj.MarineTrafficServiceVesselId(data.MarineTrafficServiceVesselId);
            if (data.PilotShiphandlingNotesUrl !== undefined) obj.PilotShiphandlingNotesUrl(data.PilotShiphandlingNotesUrl);
            if (data.PSixServiceVesselId !== undefined) obj.PSixServiceVesselId(data.PSixServiceVesselId);
	        
            if (data.Alias !== undefined) obj.Alias(data.Alias);
            if (data.AuditKey !== undefined) obj.AuditKey(data.AuditKey);
            if (data.Beam !== undefined) NullableMeasurement.update(obj.Beam, data.Beam);
            if (data.BowThruster !== undefined) BowThruster.update(obj.BowThruster, data.BowThruster);
            if (data.CallSign !== undefined) obj.CallSign(data.CallSign);
            if (data.DOS !== undefined) DeclarationOfSecurity.update(obj.DOS, data.DOS);
            if (data.ExpectedPassengerCount !== undefined) obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.GrossTonnage !== undefined) NullableMeasurement.update(obj.GrossTonnage, data.GrossTonnage);
            if (data.Guid !== undefined) obj.Guid(data.Guid);
            if (data.IMO !== undefined) obj.IMO(data.IMO);
            if (data.IsCruiseVessel !== undefined) obj.IsCruiseVessel(data.IsCruiseVessel);
            if (data.IsGovernmentVessel !== undefined) obj.IsGovernmentVessel(data.IsGovernmentVessel);
            if (data.Length !== undefined) NullableMeasurement.update(obj.Length, data.Length);
            if (data.MaxDraft !== undefined) NullableMeasurement.update(obj.MaxDraft, data.MaxDraft);
            if (data.MMSID !== undefined) obj.MMSID(data.MMSID);
            if (data.Name !== undefined) obj.Name(data.Name);
            if (data.PortOfRegistry !== undefined) obj.PortOfRegistry(data.PortOfRegistry);
            if (data.Status !== undefined) obj.Status(data.Status);
            if (data.VesselType !== undefined) obj.VesselType(data.VesselType);
            if (data.VIN !== undefined) obj.VIN(data.VIN);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Vessel.ts